import {useMemo, useState} from "react";
import {observer} from "mobx-react";
import rootStores from "@/Stores/RootStores";
import {
    Filter,
    isFilterVisible,
    CatalogRangeFilter,
    CatalogOptionsFilter,
    mapCatalogFilter
} from "@/features/catalog-filters";
import {FilterDropdown} from "@/shared/ui/FilterDropdown";
import {useCatalogFilterDrawer} from "@/widgets/catalog-filter-drawer";
import styles from "./CatalogFilter.module.scss";

type Props = {
    filter: Filter;
    isDesktop?: boolean;
    insertColors?: Record<string, string>;
};

export const CatalogFilter = observer((
    {
        filter,
        isDesktop = false,
        insertColors,
    }: Props
) => {
    const [showAll, setShowAll] = useState(false);
    const {catalogStore} = rootStores;
    const openModal = useCatalogFilterDrawer(s => s.actions.openModal);

    const handleShowAll = () => {
        setShowAll(true);
    };

    const preparedFilter = useMemo(
        () => mapCatalogFilter({filter, isDesktop}),
        [filter, isDesktop]
    );

    const handleMobileOpen = () => {
        openModal(preparedFilter.key);
    }

    // Не показываем фильтр, если ...
    if (!isFilterVisible(preparedFilter)) return null;

    switch (preparedFilter.type) {
        case "range":
            return (
                <FilterDropdown title={preparedFilter.title} isDesktop={isDesktop} onMobileOpen={handleMobileOpen}>
                    <CatalogRangeFilter
                        option={preparedFilter.options}
                        onChange={(values) => {
                            catalogStore.onBlur(values, preparedFilter.options);
                        }}
                    />
                </FilterDropdown>
            );
        default:
            return (
                <FilterDropdown title={preparedFilter.title} isDesktop={isDesktop} onMobileOpen={handleMobileOpen}>
                    <CatalogOptionsFilter
                        options={preparedFilter.options}
                        visibleOptionsCount={preparedFilter.visibleOptionsCount}
                        showAll={showAll}
                        insertColors={insertColors}
                        onShowAll={handleShowAll}
                        checkboxContainerClassName={styles.labelContainer}
                        onChange={(option) => {
                            catalogStore.onChangeFilter(option, preparedFilter.dependencies);
                        }}
                    />
                </FilterDropdown>
            );
    }
});
